import { useContext, useEffect, useState } from "react";
import { Switch } from "components/ui";
import ComponentAccessControl from "components/essentials/ComponentAccessControl/ComponentAccessControl";
import { ToastContext } from "components/dashboard/common/Toast/context/ToastContextProvider";
import { apiRoute } from "services";
import API from "services/lib/api";
import { getErrorMessage } from "utils/helper";
import { dataQueryStatus } from "utils";
import { AUTOMATION_STATUS } from "../enum";
import { AUTOMATION_UPDATE_PERMISSION } from "../permissions";

const { ERROR } = dataQueryStatus;

const AutomationsStatusSwitch = ({
    automationId,
    status,
    getAutomations,
}) => {
    const toastMessage = useContext(ToastContext);
    const [switchState, setSwitchState] = useState(
        status === AUTOMATION_STATUS.ACTIVE
    );

    const updateAutomationStatus = async (nextActive) => {
        try {
            setSwitchState(nextActive);
            const url = nextActive
                ? apiRoute.activateAutomation(automationId)
                : apiRoute.pauseAutomation(automationId);
            const res = await API.put(url);

            if (res.status === 200) {
                toastMessage(res?.data?.message || "Automation updated");
                getAutomations?.();
            }
        } catch (err) {
            setSwitchState(!nextActive);
            toastMessage(getErrorMessage(err), ERROR);
        }
    };

    useEffect(() => {
        setSwitchState(status === AUTOMATION_STATUS.ACTIVE);
    }, [status]);

    return (
        <ComponentAccessControl baseResources={AUTOMATION_UPDATE_PERMISSION}>
            <Switch
                checked={switchState}
                label={switchState ? "ON" : "OFF"}
                id={`automation-status-${automationId}`}
                onChange={(e) => updateAutomationStatus(e.target.checked)}
            />
        </ComponentAccessControl>
    );
};

export default AutomationsStatusSwitch;
